import { feedItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function FeedFlow() {
  return (
    <section id="feed" className="hll-scroll-anchor w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="LATEST ARCHIVE"
          title="大图卡片流 · 最新归档合集"
          desc="一图一合集，点进即可看黑料吃瓜网图片与黑料吃瓜网视频；每条都标了更新时间与来源角度，挑起来更快。"
          actionLabel="按时间排序"
          actionHref="#updates"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 md:gap-8 lg:grid-cols-2">
          {feedItems.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-300/60 bg-background-50"
            >
              <div className="relative h-[220px] w-full overflow-hidden md:h-[280px]">
                <img
                  src={item.image}
                  alt={`${item.title} - 黑料吃瓜网大图合集`}
                  title={`${item.title} 黑料吃瓜网高清图片`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-foreground-950/80 px-3 py-1 text-xs text-background-50">
                  {item.category}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-calendar-line text-sm"></i>
                    </span>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-eye-line text-sm"></i>
                    </span>
                    {item.views} 次浏览
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
                  <div className="flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full border border-accent-300 bg-accent-50 px-2.5 py-0.5 text-[11px] text-accent-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <a
                    href="#index"
                    className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
                  >
                    查看合集
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}